import { render, staticRenderFns } from "./AreaCodeSelect.vue?vue&type=template&id=2f13f90e&scoped=true&"
import script from "./AreaCodeSelect.vue?vue&type=script&lang=ts&"
export * from "./AreaCodeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AreaCodeSelect.vue?vue&type=style&index=0&id=2f13f90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13f90e",
  null
  
)

export default component.exports